import { PHENO_CODES } from '../../../hooks/usePhenomenaData'
import { PHENO_LEGEND_MAP } from './phenomenaUtils'

// Legenda jevů (SVG ikona + kód + název). Vytaženo z DlyJevyView — sdílené se StationGroupJevyView.
export function PhenomenaLegend({ defsMap }) {
  return (
    <div className="shrink-0">
      <table className="border-separate border-spacing-0 text-xs">
        <thead className="sticky top-0 z-20">
          <tr>
            <th colSpan={3} className="bg-gray-50 border-b border-b-gray-400 px-2 pt-[8px] pb-[8px] text-left text-xs font-semibold text-gray-500 uppercase tracking-wide whitespace-nowrap">
              Legenda
            </th>
          </tr>
        </thead>
        <tbody>
          {PHENO_CODES.map((code) => {
            const def = defsMap.get(code)
            return (
              <tr key={code} className="h-[26px]">
                <td className="px-2 py-1 text-center w-8 leading-none">
                  {def?.svg ? (
                    <span
                      className="inline-block w-4 h-4"
                      dangerouslySetInnerHTML={{ __html: def.svg }}
                    />
                  ) : (
                    <span className="text-gray-400">?</span>
                  )}
                </td>
                <td className="pr-3 py-1 font-mono font-semibold text-gray-500 leading-none">{code}</td>
                <td className="pr-2 py-1 text-gray-700 whitespace-nowrap leading-none">{PHENO_LEGEND_MAP.get(code) ?? def?.name ?? '—'}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className="text-xs text-gray-400 mt-2">Data jsou v UTC</div>
    </div>
  )
}
